import React, { Suspense, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import Loader from "../loader/Loader";

export default function PageTransition() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Suspense fallback={<Loader />}>
      <Box
        key={location.pathname}
        sx={{
          animation: "pageEnter 0.4s ease-out",
          "@keyframes pageEnter": {
            from: {
              opacity: 0,
              transform: "translateY(10px)",
            },
            to: {
              opacity: 1,
              transform: "translateY(0)",
            },
          },
        }}
      >
        <Outlet />
      </Box>
    </Suspense>
  );
}
